<template>
    <div v-if="zones.length != 0" class="text-truncate">
        <v-icon size="small">
            mdi-layers-triple-outline
        </v-icon>
        Zones: {{ zones.join(", ") }}
    </div>
    <div v-if="station.machine_setup" class="text-truncate">
        <v-icon size="small">
            mdi-robot-industrial
        </v-icon>
        {{ getMachineName(station.machine_setup) }}
    </div>
</template>

<script setup>
import { useFactoriesStore } from "@/stores/factories";
import { computed } from "vue";

const factories_store = useFactoriesStore()
const { station } = defineProps(["station"]);

const zones = computed(() => station?.zones || [])


const getMachineName = (machine_setup) => {
    const mach = factories_store.machines.find(
        (m) => m.uuid == machine_setup
    );
    return mach?.name || "machine";
}


</script>
